export enum StepsLabelPlacement {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}